import { useState, useEffect } from "react";

type ThemeMode = "light" | "dark";

/**
 * Hook to detect and track OS/system dark/light mode preference.
 * Returns the current mode and updates reactively when the OS preference changes.
 */
export function useSystemTheme(): ThemeMode {
  const [mode, setMode] = useState<ThemeMode>(() =>
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light",
  );

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      setMode(e.matches ? "dark" : "light");
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return mode;
}
